import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: palette.dai.lightBlue,
    color: palette.dai.shinyBlue,
    '&:hover': {
      backgroundColor: palette.dai.lightBlue,
      color: palette.dai.shinyBlue,
    },
  },

  outlined: {
    color: theme.palette.dai.shinyBlue,
    borderColor: theme.palette.dai.light,
    backgroundColor: theme.palette.white,
    boxShadow: 'none',
    transition: theme.transitions.create([
      'color',
      'background-color',
      'border-color',
      'box-shadow',
    ]),
    '& svg g': {
      fill: theme.palette.dai.shinyBlue,
      transition: theme.transitions.create('fill'),
    },
    '&:hover': {
      color: theme.palette.white,
      backgroundColor: theme.palette.dai.shinyBlue,
      borderColor: theme.palette.dai.shinyBlue,
      boxShadow: `0px 2px 10px 0px ${theme.palette.dai.glow}`,
      '& svg g': {
        fill: theme.palette.white,
      },
    },
    '&:focus, &:active': {
      color: theme.palette.white,
      backgroundColor: theme.palette.dai.dark,
      borderColor: theme.palette.dai.dark,
      '& svg g': {
        fill: theme.palette.white,
      },
    },
  },

  automaticWidthButtonBox: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

export default styles
